export default __webpack_public_path__ + "images/b63622f85f8fee9f5ff2840abcaa53a8-new_york_mobile.webp";